import { getRegisterFunction } from '../../utils/register.js';
import { OneUxCollapsibleSectionElement } from './OneUxCollapsibleSectionElement.js';
export const register = getRegisterFunction(OneUxCollapsibleSectionElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-collapsible-section': OneUxCollapsibleSectionElement;
    "collapsible-section-1b14b65e1717598191769d21775ee9cb": OneUxCollapsibleSectionElement;
  }
}